var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Icon } from './Icon';
export var SendIcon = function (props) { return (React.createElement(Icon, __assign({}, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.2715 3.03212C20.704 2.87969 21.1203 3.29602 20.9679 3.72847L15.0085 20.6355C14.8549 21.0712 14.2632 21.1311 14.0255 20.7349L10.0606 14.1267C10.0145 14.0498 9.95017 13.9855 9.87333 13.9394L3.26513 9.97449C2.86894 9.73678 2.92877 9.14509 3.36452 8.9915L20.2715 3.03212ZM18.3668 4.8612L4.82213 9.6354L10.3036 12.9243L18.3668 4.8612ZM11.0757 13.6964L14.3646 19.1779L19.1388 5.63325L11.0757 13.6964Z", fill: "#002333" }))); };
//# sourceMappingURL=SendIcon.js.map